import styled from 'styled-components';

export const WrapperDiv = styled.div`
	transition: 0.4s;

	@media (min-width: 1201px) {
		margin-left: 216px;
	}
`;
